<app-topmenu
  [courseName]="configuration?.courseName"
  [menu]="configuration?.menu"
  [nextDecision]="nextDecision"
></app-topmenu>
<app-header [pageName]="title"></app-header>
<div id="main-content">
  <app-documentstable
    [data]="documentsData"
    (documentOpened)="documentOpened($event)"
  ></app-documentstable>
</div>
<app-footer></app-footer>
